import React, {useEffect, useState} from 'react';
import './App.css';
import logo from "../../res/logo.svg"
import ic_apple from "../../res/ic_apple.svg"
import ic_google from "../../res/ic_google.svg"
import ic_download from "../../res/ic_download.svg"
import RippleButton from "../../componet/rippleButton";
import {judgeSource, SourceProps} from "../../componet/download";

function App() {

    const [source, setSource] = useState<SourceProps>({isAndroid: true, href: ''})

    useEffect(() => {
        const urlSource = judgeSource()
        setSource(urlSource)
    }, [])

    return (
        <div className="App">

            <img src={logo} className="App-logo" alt={'logo'}/>

            {/* <img src={beatbot} className="App-logo-beatbot" alt={'logo BeatBot'}/> */}
            <div style={{flex: 1}}/>
            <RippleButton icon={source.isAndroid ? ic_google : ic_apple} url={source.href}/>
            {source.isAndroid && (
                <RippleButton icon={ic_download} url={"https://globalres.beatbot.com/app/android.apk"}/>
            )}
        </div>
    );
}

export default App;
